export const LibraryControlSystemUpdate = [
    'id',
    'description',
    'phase',
    'controlTypeId',
    'threshold',
    'active',
    'action',
    'reviewFrequencyUnits',
    'reviewFrequencyPeriod',
];

export const LibraryControlOrgUpdate = [...LibraryControlSystemUpdate, 'controlPhaseId', 'responsibleFunctionId'];
